export const pcgSettingsDevelopment = {"mode":"Development","apiBaseUrl":"https://localhost:5001","rollbarPostClientToken":"70fa1d1f0ecc4727910a6029ccacc677"};
